/* eslint-disable no-loop-func */
//Table ant design
import { Table } from 'ant-table-extensions';
import { Spin } from 'antd';

import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
    dateToTimestamp, timestampToDate, timestampToDateWithoutSecond
} from '../../common/handleTimestamp';
import tbAuditLogsController from '../../redux/api/tbAuditLogController';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';


const AuditLogs = ({ deviceId }) => {
    const token = localStorage.getItem('token');
    const { t } = useTranslation();

    const [datepicker, setDatepicker] = useState('');

    const [curPage, setCurPage] = useState(1);
    const [pagination, setPagination] = useState({
        current: curPage,
        pageSize: 10,
        total: 10,
        position: ['topLeft', 'none'],
    });
    const [loading, setLoading] = useState(false);

    const [dataOperation, setDataOperation] = useState([]);
    const [columnOperation, setColumnOperation] = useState([
        {
            title: 'STT',
            dataIndex: 'index',
            key: 'index',
            width: '80px',
        },
        {
            title: t('time'),
            dataIndex: 'time',
            key: 'time',
            width: '200px',
        },
        {
            title: t('status'),
            dataIndex: 'status',
            key: 'status',
            width: '150px',
        },
        {
            title: t('name'),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t('details'),
            dataIndex: 'details',
            key: 'details',
        },
    ]);

    const handleConvertMethod = (method) => {
        switch (method) {
            case "alert":
                return "Cảnh báo";
            case "setMode":
                return "Chế độ";
            case "pressure1":
                return "Áp suất";
            case "setPower":
                return "Nguồn";
            case "pump1":
                return "Bơm F-P";
            case "pump2":
                return "Bơm P-P";
            case "pump3":
                return "Bơm CIP-P";
            case "pump4":
                return "Bơm CP-04A"
            case "pump5":
                return "Bơm CP-04B"
            case "pump6":
                return "Van S2"
            case "float1":
                return "Phao L1";
            case "float2":
                return "Phao L2";
            case "float3":
                return "Phao L3";
            case "float4":
                return "Phao L4"
            case "float5":
                return "Phao L5"
            case "inverter1":
                return "Biến Tần 1";
            case "inverter2":
                return "Biến Tần 2";
            case "inverter3":
                return "Biến Tần 3";
            case "inverter4":
                return "Biến Tần 4"
            case "inverter5":
                return "Biến Tần 5"
            case "inverter6":
                return "Biến Tần 6"
            case "pressureMax1":
                return "Ngưỡng Áp Suất 1"
            case "pressureMax2":
                return "Ngưỡng Áp Suất 2"
            case "setConfiguration":
                return "Cấu hình"
            default:
                return method;
        }
    }

    const handleConvertParams = (params) => {
        switch (params) {
            case "true":
                return "Bật";
            case "false":
                return "Tắt";
            case { "setTime1": 2, "setTime2": "40" }:
                return
            default:
                return params;
        }
    }

    const fetchData = useCallback(async (startTs, endTs) => {
        setLoading(true);
        const dataAudit = await tbAuditLogsController.getAuditLogsByEntityId(
            token,
            deviceId,
            startTs,
            endTs
        );

        // operation
        let rowDataExportOperation = [];
        let indexRowExportOperation = 0;
        dataAudit.data.map((item, idx) => {
            let rowData = {
                key: idx,
                index: ++indexRowExportOperation,
                time: timestampToDate(item.createdTime),
                name: item.userName,
                status: item.actionStatus,
                details: `${item.actionData.method
                    ? handleConvertMethod(item.actionData.method)
                    : "Chỉnh sửa ảnh"
                    }${item.actionData.params ?
                        (item.actionData.params === "true"
                            ? ": Bật"
                            : item.actionData.params === "false"
                                ? ": Tắt"
                                : ": " + item.actionData.params
                        )
                        : ""
                    }`
            };
            rowDataExportOperation.push(rowData);
        })
        setDataOperation(rowDataExportOperation);
        setPagination({ ...pagination, total: indexRowExportOperation });
        setLoading(false);
    }, []);

    const handleGetData = (datepick) => {
        setDatepicker(datepick);
        if (deviceId && datepick) {
            const startTs = dateToTimestamp(datepick + ' 00:00:00');
            const endTs = dateToTimestamp(datepick + ' 23:59:59');
            fetchData(startTs, endTs);
        }
    };

    const handleUpdateTable = () => {
        if (deviceId && datepicker) {
            const startTs = dateToTimestamp(datepicker + ' 00:00:00');
            const endTs = dateToTimestamp(datepicker + ' 23:59:59');
            fetchData(startTs, endTs);
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        if (curPage !== pagination.current) {
            setCurPage(pagination.current);
        }
        setPagination(pagination);
    };
    const [tableContent, setTableContent] = useState();

    useEffect(() => {
        let html;
        if (loading) html = <Spin />;
        else if (dataOperation.length > 0) {
            html = (
                <Table
                    columns={columnOperation}
                    dataSource={dataOperation}
                    pagination={pagination}
                    onChange={handleTableChange}
                    scroll={{ x: '1000px', y: '45vh' }}
                />
            );
        } else {
            html = <Table />
        }
        setTableContent(html);
    }, [columnOperation, dataOperation, pagination, loading]);

    const ExportCSV = ({ dataRow, dataCol, fileName }) => {
        const fileType =
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';

        const exportToCSV = (dataRow, dataCol, fileName) => {
            var fields = dataCol?.map((e) => e.key);

            const columnHeader = dataCol?.map((e) => e.title);

            const workBook = new Workbook();
            const workSheet = workBook.addWorksheet(t('audit-log'));
            workSheet.addRow(columnHeader);

            dataRow.map((e) => {
                const row = workSheet.addRow(
                    fields.map((fieldName) => {
                        return e[fieldName]
                    })
                );
                for (let i = 1; i <= fields.length; i++) {
                    const col = row.getCell(i);

                    col.fill = e.alert
                        ? {
                            type: 'pattern',
                            pattern: 'solid',

                            fgColor: { argb: 'FF0000' },
                        }
                        : '';
                }
            });
            workBook.xlsx.writeBuffer().then((data) => {
                let blob = new Blob([data], {
                    type: fileType,
                });
                saveAs(blob, fileName + fileExtension);
            });
        };

        return (
            <Button
                id="exportOperation"
                variant="primary"
                onClick={(e) => exportToCSV(dataRow, dataCol, fileName)}
            >
                + {t('export-excel')}
            </Button>
        );
    };

    return (
        <>
            <Row>
                <Col md={6}>
                    <Form.Label>{t('pick-date')}</Form.Label>
                    <Form.Control
                        type="date"
                        id="datepicker"
                        onChange={(e) => handleGetData(e.target.value)}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ marginTop: '12px' }}>
                        {dataOperation && dataOperation.length > 0 ? (
                            <ExportCSV
                                dataRow={dataOperation}
                                dataCol={columnOperation}
                                fileName={`Operation[` + datepicker + ']'}
                            />
                        ) : (
                            <Button id="exportOperation" variant="primary" disabled>
                                + {t('export-excel')}
                            </Button>
                        )}
                        <Button
                            id="updateDeviceBtn"
                            variant="primary"
                            onClick={handleUpdateTable}
                        >
                            {t('update')}
                        </Button>
                    </div>
                </Col>
            </Row>

            <div className="spinner-grow" role="status" id="spinner" hidden></div>
            {tableContent}
        </>
    );
};

export default AuditLogs;
